import styled from "styled-components";

import { flexColumn, rem } from "@styles/Utilities.styled";


export const StyledFullAllergiesModal = styled.div`
  padding-bottom: 1rem;

  .dialog-body {
    ${flexColumn}
    gap: 2rem;
    margin-top: 0.5rem;
  }

  .severity-wrapper {
    & > p {
      font-size: ${rem(14)};
      font-weight: 500;
    }
  }

  .tags-wrapper {
    display: flex;
    flex-flow: row wrap;
    gap: 0.5rem;
    margin-top: 0.5rem;
  }
`;
